import * as dayjs from "dayjs";

// eslint-disable-next-line no-unused-vars
const getDefaultDateSettings = (settings, initialDates) => {
	// CONFIG
	const DEFAULT_DAY_RANGE = 7;
	const DEFAULT_INITIAL_DEPARTURE_TODAY_PLUS_DAYS = 1;
	const DEFAULT_INITIAL_MIN_DEPARTURE_TODAY_PLAY_DAYS = 0;
	const DEFAULT_INITIAL_MAX_RETURN_TODAY_PLUS_DAYS = 365;

	const initialDepartureDate = dayjs(initialDates?.[0] ?? null);
	const initialReturnDate = dayjs(initialDates?.[1] ?? null);
	const defaultInitialDepartureDate = dayjs()
		.startOf("day")
		.add(
			settings?.InitialRolloverAvailableDays ??
				DEFAULT_INITIAL_DEPARTURE_TODAY_PLUS_DAYS,
			"day"
		);
	const defaultInitialMinDate = dayjs()
		.startOf("day")
		.add(
			settings?.RolloverAvailableDays ??
				DEFAULT_INITIAL_MIN_DEPARTURE_TODAY_PLAY_DAYS,
			"day"
		);
	const defaultInitialMaxDate = dayjs()
		.startOf("day")
		.add(
			settings?.RolloverMaxAvailableDays ??
				DEFAULT_INITIAL_MAX_RETURN_TODAY_PLUS_DAYS,
			"day"
		);
	const defaultAvailableDate = dayjs(settings?.DefaultAvailableDate ?? null);
	const defaultMaxAvailableDate = dayjs(
		settings?.DefaultMaxAvailableDate ?? null
	);
	let defaultDepartureDate;
	let defaultReturnDate;

	// Handle getting default departure date based on previous session / initial dates
	if (initialDepartureDate.isValid()) {
		if (defaultAvailableDate.isValid()) {
			if (initialDepartureDate.isBefore(defaultAvailableDate)) {
				defaultDepartureDate = defaultAvailableDate;
			} else {
				defaultDepartureDate = initialDepartureDate;
			}
		} else if (initialDepartureDate.isBefore(defaultInitialDepartureDate)) {
			defaultDepartureDate = defaultInitialDepartureDate;
		} else {
			defaultDepartureDate = initialDepartureDate;
		}
	} else if (defaultAvailableDate.isValid()) {
		defaultDepartureDate = defaultAvailableDate;
	} else {
		defaultDepartureDate = defaultInitialDepartureDate;
	}

	if (defaultMaxAvailableDate.isValid()) {
		if (defaultDepartureDate.isAfter(defaultMaxAvailableDate)) {
			defaultDepartureDate = defaultInitialDepartureDate;
		}
	}

	// Handle getting default return date based on default departure date
	if (initialReturnDate.isValid()) {
		if (initialReturnDate.isBefore(defaultDepartureDate)) {
			defaultReturnDate = dayjs(defaultDepartureDate).add(
				DEFAULT_DAY_RANGE,
				"day"
			);
		} else {
			defaultReturnDate = initialReturnDate;
		}
	} else {
		defaultReturnDate = dayjs(defaultDepartureDate).add(
			DEFAULT_DAY_RANGE,
			"day"
		);
	}

	if (defaultMaxAvailableDate.isValid()) {
		if (defaultReturnDate.isAfter(defaultMaxAvailableDate)) {
			defaultReturnDate = dayjs(defaultDepartureDate).add(
				DEFAULT_DAY_RANGE,
				"day"
			);

			// Check again with the default date
			if (defaultReturnDate.isAfter(defaultMaxAvailableDate)) {
				defaultReturnDate = null;
			}
		}
	}

	const validatedDates = [];

	if (defaultDepartureDate) {
		validatedDates.push(defaultDepartureDate.format());

		if (defaultReturnDate) {
			validatedDates.push(defaultReturnDate.format());
		}
	}

	return {
		defaultDates: validatedDates,
		minDate: dayjs(defaultAvailableDate)?.isValid()
			? defaultAvailableDate
			: defaultInitialMinDate,
		maxDate: dayjs(defaultMaxAvailableDate).isValid()
			? defaultMaxAvailableDate
			: defaultInitialMaxDate
	};
};

export default getDefaultDateSettings;
export { getDefaultDateSettings };
